import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权

const whiteList = ['/login'] // 不重定向白名单

/** 从路由表中获取第一个可访问的路径 */
function getFirstAccessiblePath(routes) {
  for (const route of routes) {
    if (route.hidden) continue
    if (route.children && route.children.length) {
      for (const child of route.children) {
        if (!child.hidden && child.path && child.path !== '*') {
          return child.path
        }
      }
    }
    if (route.path && route.path !== '' && route.path !== '*') {
      return route.path
    }
  }
  return '/error/404'
}

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.permissions.length === 0) {
        store
          .dispatch('GetInfo')
          .then((res) => {
            // 拉取用户信息
            console.log(res)
            const permissions = res.data.permissions // note: permissions must be a array! such as: ['editor','develop']
            store.dispatch('GenerateRoutes', { permissions }).then(() => {
              // 根据permissions权限生成可访问的路由表
              router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
              // 如果当前路径无完整匹配路由（仅匹配到Layout父级但无子路由），重定向到第一个可访问页面
              const resolved = router.resolve(to.path)
              const { matched } = resolved.route
              // 有效匹配：嵌套路由至少2层(Layout+页面)，或单层路由有具体path(如/login)
              const isFullMatch =
                matched.length >= 2 ||
                (matched.length === 1 && matched[0].path !== '')
              if (!isFullMatch) {
                const firstPath = getFirstAccessiblePath(
                  store.getters.addRouters,
                )
                next({ path: firstPath, replace: true })
              } else {
                next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
              }
            })
          })
          .catch((err) => {
            store.dispatch('FedLogOut').then(() => {
              Message.error(err || '登录信息失效，请重新登录')
              next({ path: '/' })
            })
          })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})
